var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signout"},[_c('h1',[_vm._v("Déconnexion")]),_c('br'),_c('v-progress-circular',{attrs:{"size":70,"width":3,"color":_vm.$vuetify.theme.primary,"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }